import { Badge } from '@wix/design-system';
import { FunctionComponent, useState } from 'react';
import { InnerLink } from '../../../../InnerLink';
import { Category } from '@wix/answers-api';
import css from './index.module.scss';
import { DATA_HOOKS } from '../../../../../dataHooks';

export type CategoryProps = {
  category: Category;
  onClick: (category: Category) => void;
};

export const CategoryTag: FunctionComponent<CategoryProps> = ({
  category,
  onClick,
}) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <InnerLink
      onClick={() => onClick(category)}
      className={css.categoryTag}
      href={category.uri ?? ''}
      dataHook={DATA_HOOKS.SEARCH_RESULT_ITEM_CATEGORY_NAME}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Badge
        type="outlined"
        skin={isHover ? 'neutralStandard' : 'neutralLight'}
        size="tiny"
      >
        {category.name}
      </Badge>
    </InnerLink>
  );
};
